import i18next from 'i18next';

export default function initI18n(): void {
  i18next.addResourceBundle('en', 'ui', {
    errorBoundaryTitle: 'Oops, something went wrong!',
    errorBoundaryRetry: 'Try again?',
    themeBody1Label: 'Body 1:',
    themeBody2Label: 'Body 2:',
    themeLinkText: 'This is a link.',
    themeButtonLabel: 'Button -',
    uploadDropFilesHere: 'Drop files here',
    uploadReplaceExisting: 'Replace existing',
    uploadUploadingEllipsis: 'Uploading...',
    uploadUploadingProgress: 'Uploading... ({{uploaded}}/{{total}})',
    uploadClose: 'Close',
    uploadResultsTitle: 'Upload Results',
    uploadSuccessCount: 'Successfully uploaded {{count}} file(s)',
    unpinUser: 'Unpin user',
    userUnpinned: 'User unpinned',
    clipboardCopyFailed: 'Failed to copy to clipboard',
    themeInfoMessage: 'This is an info message.',
    themeWarningMessage: 'This is a warning message.',
    themeSuccessMessage: 'This is a success message.',
    themeErrorMessage: 'This is an error message.',
    themeAlertMessage: 'This is a {{severity}} alert message.',
  });
}
